import isNumberLike from './isNumberLike';

export function transformCssUnit(num: string) {
  if (isNumberLike(num)) {
    return num + 'px';
  } else {
    return num;
  }
}
